import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { Status as AkStatus } from '@atlaskit/status/element';
import { FabricElementsAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { fg } from '@atlaskit/platform-feature-flags';
import { useInlineAnnotationProps } from '../../ui/annotations/element/useInlineAnnotationProps';
export default /*#__PURE__*/memo(function Status(props) {
  var text = props.text,
    color = props.color,
    localId = props.localId;
  var inlineAnnotationProps = useInlineAnnotationProps(props);
  if (fg('editor_inline_comments_on_inline_nodes')) {
    return /*#__PURE__*/React.createElement("span", _extends({}, inlineAnnotationProps, {
      role: fg('editor_a11y_status_renderer_description') ? 'emphasis' : undefined
    }), /*#__PURE__*/React.createElement(FabricElementsAnalyticsContext, {
      data: {
        userContext: 'document'
      }
    }, /*#__PURE__*/React.createElement(AkStatus, {
      text: text,
      color: color,
      localId: localId,
      role: fg('editor_a11y_status_renderer_description') ? undefined : 'presentation',
      isBold: fg('platform-component-visual-refresh')
    })));
  }
  return /*#__PURE__*/React.createElement(FabricElementsAnalyticsContext, {
    data: {
      userContext: 'document'
    }
  }, fg('editor_a11y_status_renderer_description') ? /*#__PURE__*/React.createElement("span", {
    role: "emphasis"
  }, /*#__PURE__*/React.createElement(AkStatus, {
    text: text,
    color: color,
    localId: localId,
    isBold: fg('platform-component-visual-refresh')
  })) : /*#__PURE__*/React.createElement(AkStatus, {
    text: text,
    color: color,
    localId: localId,
    role: "presentation",
    isBold: fg('platform-component-visual-refresh')
  }));
});